module.exports = __webpack_public_path__ + "img/banner3@2x.ba73a55e.png";